import { observer } from 'mobx-react';
import { Flex } from 'antd';
import JobCard from './JobCard';
import { StagesStore } from '../../../../DataSource/Stores/Cabinet/StagesStore';

const NewJobsPage = () => {
  return (
    <Flex vertical gap={12}>
      {StagesStore.dataQueueList.map((job) => (
        <JobCard key={job._id} {...job} />
      ))}
    </Flex>
  );
};

export default observer(NewJobsPage);
